<template>
  <div id="app">
    <div class="header">
      <quiz-header v-if="getStartStatus"></quiz-header>
    </div>
    <div class="content">
      <quiz-box v-if="getStartStatus"></quiz-box>
      <div style="float: none; clear: both"></div>
    </div>
  </div>
</template>

<script>
import QuizHeader from './components/QuizHeader.vue';
import QuizBox from './components/QuizBox.vue';
import QuizIntro from './components/QuizIntro.vue';
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  name: 'app',

  components: {
    QuizHeader,
    QuizBox,
    QuizIntro,
  },

  methods: {
    ...mapMutations( ['setStartStatus'] ),

    startQuiz() {
      this.setStartStatus( true );
    },
  },

  mounted() {
    this.startQuiz();
  },

  computed: {
    ...mapGetters( [
      'getStartStatus',
    ] ),
  },
}
</script>

<style>
:root {
  --imc-primary-color: var(--color-content-primary);
  --imc-secondary-color: var(--color-content-secondary);
  --imc-alternate-color: var(--color-content-bg-alt);
}

.content h2 {
  margin-bottom: 0.5rem;
}

/* Popup button box*/
.mobile.button-content {
  padding: 20px;
}

.button-content {
  padding: 20px 0;
}

.option-normal {
  position: relative;
  padding: 0.75rem;
  width: 100%;
  background: #fff;
  text-transform: capitalize;
  text-align: left;
  box-shadow: 0 0 0 2px #ccc;
}

.option-normal .image {
  float: left;
  width: 60px;
  text-align: center;
  margin: 9px 0;
  vertical-align: middle;
}

.option-normal .image img {
  max-width: 36px;
  max-height: 36px;
  text-align: center;
  display: block;
  margin: 0 auto;
  vertical-align: middle;
}

.option-normal .option {
  position: relative;
  font-weight: bold;
  float: left;
  font-size: 15px;
  line-height: 36px;
  margin: 9px 10px 9px 20px;
}

.option-normal:focus {
  outline: none;
}

.option-normal:hover,
.option-selected {
  outline: none;
  z-index: 1;
}

.option-selected {
  box-shadow: 0 0 0 2px var(--imc-primary-color);
  background: var(--imc-alternate-color);
}

.option-normal:hover {
  box-shadow: 0 0 0 2px #666;
}

.mobile_view {
  display: flex;
  flex-direction: row-reverse;
}

.left-content {
  width: 60%;
  padding-right: 1.5rem;
}

.right-content {
  width: 40%;
  padding-left: 1.5rem;
}

@media only screen and (max-width: 1024px) {
  .mobile_view {
    flex-direction: column;
  }

  .left-content,
  .right-content {
    width: 100%;
    padding: 0;
  }

  .right-content {
    margin-bottom: 1.5rem;
  }
}

.btn-prev {
  float: left;
}

.btn-next {
  float: right;
}

.content ol,
.content li {
  list-style: none;
  padding: 0;
  margin: 0;
}

.content ol {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.content ol li {
  position: relative;
  padding: 0;
  width: 100%;
  background-color: #fff;
}

.content ol li:not(:first-child) {
  margin-top: 2px;
}
</style>